module.exports = __webpack_public_path__ + "img/privacy_preserving.0f27d87d.jpg";